import React from 'react';
import LandingMediaKitProposal from '../TNOMediaKitProposal';

const LandingMediaKitLedHome = (props) => (
  <LandingMediaKitProposal {...props} staticOnly forcedSlug="ledhome" />
);

export default LandingMediaKitLedHome;
